// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1kkne","header":"MessagesList_header__ajDsY","chat":"MessagesList_chat__3zsbw"};